import { useEffect } from 'preact/hooks';

/** Per-route <title> and meta description. */
export function usePageMeta(title: string, description: string) {
  useEffect(() => {
    document.title = title === 'Ayonix Studio' ? 'Ayonix Studio — Discover. Save. Create.' : `${title} · Ayonix Studio`;
    let tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!tag) { tag = document.createElement('meta'); tag.name = 'description'; document.head.append(tag); }
    tag.content = description;
  }, [title, description]);
}
